"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlBrTagImporter = void 0;
var tslib_1 = require("tslib");
var rich_utils_1 = require("../../../core/model/rich-utils");
var fixed_1 = require("@devexpress/utils/lib/intervals/fixed");
var runs_1 = require("../containers/runs");
var base_1 = require("./base");
var HtmlBrTagImporter = (function (_super) {
    tslib_1.__extends(HtmlBrTagImporter, _super);
    function HtmlBrTagImporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HtmlBrTagImporter.prototype.elementTag = function () {
        return "BR";
    };
    HtmlBrTagImporter.prototype.importBefore = function () {
        var breakChar = this.element.style.pageBreakBefore == "always" ?
            rich_utils_1.RichUtils.specialCharacters.PageBreak :
            rich_utils_1.RichUtils.specialCharacters.LineBreak;
        this.addRun(new runs_1.ImportedTextRunInfo(this.importer.modelManager.model, this.importer.measurer, breakChar, this.importer.htmlImporterMaskedCharacterProperties.getBundleFrom(this.element, new fixed_1.FixedInterval(this.importer.currPosition, 1))));
    };
    HtmlBrTagImporter.prototype.isImportChilds = function () {
        return false;
    };
    HtmlBrTagImporter.prototype.importAfter = function () {
    };
    return HtmlBrTagImporter;
}(base_1.HtmlTagImporterBase));
exports.HtmlBrTagImporter = HtmlBrTagImporter;
